import styled from "styled-components";

import { QUERIES, SPACING, TOUCH_TARGET } from "../../utils/constants";
import { BaseButton } from "../Button";

const PAGE_BUTTON_SIZE = 31;

export const PaginationBar = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.sm + SPACING.xs}px;
`;

export const PaginationSummary = styled.span`
  color: var(--color-text-secondary);
  font-size: var(--text-xs);
`;

export const PaginationControls = styled.div`
  display: flex;
  align-items: stretch;
  gap: ${SPACING.xs}px;
`;

export const PageButton = styled(BaseButton)<{ $active?: boolean }>`
  display: grid;
  place-items: center;
  min-width: ${PAGE_BUTTON_SIZE}px;
  min-height: ${PAGE_BUTTON_SIZE}px;
  padding: 0 ${SPACING.xs}px;
  border: 1px solid
    ${({ $active }) =>
      $active ? "var(--color-primary)" : "var(--color-border)"};
  border-radius: 7px;
  background: ${({ $active }) =>
    $active
      ? "color-mix(in srgb, var(--color-primary) 9%, transparent)"
      : "transparent"};
  color: ${({ $active }) =>
    $active ? "var(--color-primary)" : "var(--color-text-default)"};
  cursor: pointer;
  font-family: inherit;
  font-size: var(--text-xs);
  font-weight: ${({ $active }) => ($active ? 700 : 500)};

  &:hover:not(:disabled) {
    border-color: var(--color-primary);
  }

  & > svg {
    font-size: var(--text-md);
  }

  @media ${QUERIES.tabletLargeAndDown} {
    min-width: ${TOUCH_TARGET}px;
    min-height: ${TOUCH_TARGET}px;
  }
`;

// Not a button: there is no single page it could send you to.
export const PageEllipsis = styled.span`
  display: grid;
  place-items: center;
  padding: 0 ${SPACING.xxs}px;
  color: var(--color-text-muted);
  font-size: var(--text-xs);
`;
